<div class="flex">
  @if (!isLg()) {
    <shell-navbar class="fixed top-0 z-[1] h-[100vh] w-[10rem] bg-[#0A0F21]" />
  }
  <div
    class="z- relative z-[11] ml-[8rem] flex h-[100vh] w-full flex-col items-center justify-start space-y-[3.2rem] overflow-hidden rounded-[2rem] bg-dark-100 lg:ml-0 lg:space-y-[2.2rem] lg:rounded-none"
  >
    <div class="z-[1] flex items-center space-x-[0.5rem] pt-[3.8rem] lg:pt-[11.1rem]">
      <img class="w-[4.9986rem]" src="/assets/images/logo/logo.svg" />
      <img class="w-[10.906rem]" src="/assets/images/logo/text.svg" />
    </div>

    <div class="flex flex-col items-center space-y-[2.4rem]">
      <div class="flex flex-col items-center space-y-[0.2rem] lg:space-y-[0.4rem]">
        <span
          class="text-[2.8rem] font-400 leading-[4rem] text-light-600 lg:text-[2.4rem] lg:leading-[3.2rem]"
          i18n="@@notfound.title"
          >Страница не найдена</span
        >
        <span
          class="text-[1.5rem] font-350 leading-[2.2rem] text-light-300 lg:text-[1.3rem] lg:leading-[1.6rem]"
          i18n="@@notfound.desc"
          >Похоже, Вы попали сюда случайно</span
        >
      </div>
      <a
        routerLink="/"
        class="flex h-[4.8rem] items-center justify-center space-x-[0.8rem] rounded-[1rem] bg-blue-400 px-[2rem] custom-transition-all hover:bg-blue-500"
      >
        <span class="text-[1.4rem] font-400 leading-[2rem] text-white" i18n="@@notfound.tomain">На главную</span>
        <i class="icon_new icon_home text-[2rem] !text-white"></i>
      </a>
    </div>
    <img
      loading="lazy"
      fetchpriority="low"
      class="pointer-events-none absolute top-[2rem] max-h-[90%] max-w-[80%] z-[0] pr-[1.5rem] lg:top-[29rem] lg:w-full lg:max-w-[70rem] lg:scale-[1.25]"
      src="/assets/images/404/404Background.webp"
    />
  </div>
</div>
